module.exports = __webpack_public_path__ + "img/bot_metatrader4.0dec0ce9.png";